module.exports = __webpack_public_path__ + "static/media/ic_send_black.d5cb0d28.svg";